export default "__VITE_ASSET__CDWuNpDn__"